"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("./utils/createSvgIcon"));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/_react.default.createElement("path", {
  d: "M20.75 14.12a4 4 0 0 0-3.43.72 11.73 11.73 0 0 0-1.12-2.72.26.26 0 0 1 0-.24 11.73 11.73 0 0 0 1.12-2.72 4 4 0 0 0 3.43.71A4 4 0 0 0 19.51 2a4.06 4.06 0 0 0-3.76 4 10 10 0 0 1-1 4.28.25.25 0 0 1-.41 0A11.47 11.47 0 0 0 5.75 6.5c-1.06 0-4.29.34-5.3 1.1a.5.5 0 0 0 .16.88l11.63 3.28a.25.25 0 0 1 0 .48L.61 15.52a.5.5 0 0 0-.16.88c1 .76 4.24 1.1 5.3 1.1a11.47 11.47 0 0 0 8.59-3.86.25.25 0 0 1 .41 0 10 10 0 0 1 1 4.28 4.06 4.06 0 0 0 3.76 4 4 4 0 0 0 1.24-7.87Zm-1 5.88a2 2 0 1 1 2-2 2 2 0 0 1-2 2Zm0-16a2 2 0 1 1-2 2 2 2 0 0 1 2-2Z"
}), 'Scissors');

exports.default = _default;